import http from './http';

export class EntityService {

    constructor(entityName) {
        this.entityName = entityName;
    }

    read = body => {
        const postedData = {
            ...body
        };
        return http.post(`/${this.entityName}`, postedData)
    }

    readGet = body => {
        const postedData = {
            ...body
        };
        return http.get(`/${this.entityName}`, postedData)
    }

    readOnly = body => {
        const postedData = {
            ...body,
        };
        return http.post(`/${this.entityName}`, postedData)
    }


    readById = (id) => {
         
        return http.post(`/${this.entityName}`, { id }, { params: { id } })
    }
    readGetById = () => {
        return http.get(`/${this.entityName}`)
    }
    readByFilter = (filterBody) => {
        return http.post(`/${this.entityName}`, filterBody, { params: filterBody })
    }
    readGetByFilter = (filterBody) => {
         
        return http.get(`/${this.entityName}`, filterBody, { params: filterBody })
    }
    add = (body) => {
        return http.post(`/${this.entityName}`, body)
    }
    addGet = (body) => {
        return http.get(`/${this.entityName}`, body)
    }
    update = (body) => {
        return http.post(`/${this.entityName}`, body)
    }
    delete = (id) => {
        return http.post(`/${this.entityName}/${id}`)
    }
    status = body => {
        const postedData = {
            ...body
        };
        return http.post(`/${this.entityName}`, postedData, { params: body })
    }
}
